/** The login route's `validateSearch`: keeps `redirect` only when it is a string. */
export function validateLoginSearch(search) {
    return { redirect: typeof search.redirect === 'string' ? search.redirect : undefined };
}
/** The set-password route's `validateSearch`: keeps `token` only when it is a string. */
export function validateSetPasswordSearch(search) {
    return { token: typeof search.token === 'string' ? search.token : undefined };
}
/**
 * Which save last wrote each key. Saves overlap (one setting, then another, or two quick
 * clicks), and an older save answering or failing late must not undo a newer one, so each save
 * may only touch the keys it is still the newest write of.
 */
export function createSaveTracker() {
    let saveCount = 0;
    const latestSaveOf = new Map();
    return {
        /** Records a save of `keys` and returns its id. */
        start(keys) {
            saveCount += 1;
            keys.forEach((key) => latestSaveOf.set(key, saveCount));
            return saveCount;
        },
        /** The keys this save is still the newest write of. */
        keysOwnedBy(params) {
            const { saveId, keys } = params;
            return keys.filter((key) => latestSaveOf.get(key) === saveId);
        },
    };
}
